import axios from 'axios';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
//service
import Services from './index.service';
//interfaces
import { QuoteSentTimerLogProps, QuoteSentTimerLogServiceProps, TimerOnMapProductProps } from 'models/QuoteSentTimerLog';

export default class QuoteSentTimerLogSevices extends Services<QuoteSentTimerLogServiceProps, QuoteSentTimerLogProps> {
  TimerOnMapProduct = (data: TimerOnMapProductProps) => {
    const config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/QuoteSentTimerLog/TimerOnMapProduct`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: data,
      method: MethodsTypes.post
    };

    return axios(config);
  };
}
